import UltMeta, { Meta } from "@/meta/UltMeta/index";

class InstallPromotionCommissionState extends UltMeta {
    UNSETTLED = new Meta(1, "未结算");
    SETTLED = new Meta(2, "已结算", "color-info");
}

export const INSTALL_PROMOTION_COMMISSION_STATE = new InstallPromotionCommissionState();

class InstallPromotionCommissionType extends UltMeta {
    WX = new Meta(1, "微信");
}

export const INSTALL_PROMOTION_COMMISSION_TYPE = new InstallPromotionCommissionType();
